if (document.getElementsByClassName('elite-features').length > 0) {
  require('./elite')
}

if (document.getElementById('js-paypal-button')) {
  require('./braintree')
}

export {}
